<template>
  <div class="flex-grow-1 d-flex distribution-details">
    <div class="col-sm-12 col-md-9 col-lg-7">
      <h3 class="m-0 distribution-title">{{ getDistributionTitle(distribution) }} </h3>
      <distribution-description v-if="expanded" :distribution="distribution" :distributions="distributions"
        :distributionDescriptionIsExpanded="distributionDescriptionIsExpanded"
        :getDistributionDescription="getDistributionDescription"
        :toggleDistributionDescription="toggleDistributionDescription"
        :distributionDescriptionIsExpandable="distributionDescriptionIsExpandable" />
      <distribution-expanded-content v-if="expanded" :contentList="distributionVisibleExpandedContent"
        :distribution="distribution" :distributionIsExpanded="distributionIsExpanded"
        :showLicensingAssistant="showLicensingAssistant" :showLicence="showLicence"
        :filterDateFormatEU="filterDateFormatEU" :showArray="showArray" :showNumber="showNumber"
        :showObject="showObject" :showObjectArray="showObjectArray"
        :appendCurrentLocaleToURL="appendCurrentLocaleToURL" />
      <e-c-more :label="expanded ? 'Show less' : 'Show more'" :upArrow="expanded"
        :action="() => toggleDistribution(distribution.id)"
        class="row ecl-button--secondary ecl-tabs__toggle text-primary mb-3 mt-2" /> 
    </div>
  </div>
</template>

<script>
import {
  DistributionDescription,
  DistributionExpandedContent
} from '@piveau/piveau-hub-ui-modules';

import ECMore from "@/components/ECMore";

export default {
  name: "ECDistributionDetails",
  components: {
    ECMore,
    DistributionExpandedContent,
    DistributionDescription
  },
  props: [
    "getDistributionTitle",
    "distribution",
    "distributions",
    "distributionDescriptionIsExpanded",
    "getDistributionDescription",
    "toggleDistributionDescription",
    "distributionDescriptionIsExpandable",
    "distributionVisibleContent",
    "distributionExpandedContent",
    "distributionIsExpanded",
    "showLicensingAssistant",
    "showLicence",
    "filterDateFormatEU",
    "showArray",
    "showNumber",
    "showObject",
    "showObjectArray",
    "appendCurrentLocaleToURL",
    "distributionCanShowMore",
    "toggleDistribution",
    "getDistributionFormat",
  ],
  computed: {
    distributionVisibleExpandedContent() {
      return [...new Set(this.distributionVisibleContent
        .concat(this.distributionExpandedContent))];
    },
    expanded() {
      return this.distributionIsExpanded(this.distribution.id)
    }
  }
}
</script>

<style lang="scss" scoped>
 
.distribution-details {
  width: 50%;
  .distribution-title {
    white-space: nowrap;       /* Prevent text from wrapping */
  overflow: hidden;          /* Hide overflow */
  text-overflow: ellipsis;   /* Show ellipsis (...) */
  width: 450px;   
    overflow-wrap: break-word;
  }
  .show-more{
    padding: 2px !important;
    margin-left: -4px !important;
  }
  .show-more:hover {
    border-color: #0e47cb !important;
    color: #0e47cb !important;
    background-color: #fff !important;
    padding: 2px !important;
  }
}
</style>
